var _dec, _class;

import { model, Model, prop } from "mobx-keystone";
export let SizeModel = (_dec = model("resources/SizeModel"), _dec(_class = class SizeModel extends Model({
  width: prop().withSetter(),
  height: prop().withSetter()
}) {}) || _class);